/* eslint-disable camelcase */
import { dateTimeService } from '@mdc/services';
import { CopyButton } from '@mdc/ui';

const TIMEOUT_DURATION = {
    'short': '3',
    'long': '5'
};

const getHumanizedDate = (date, t, lang) => dateTimeService.getDateTimeString(date) + ' ' + t('[ {{dateHumanized}} ago ]', { dateHumanized: dateTimeService.dateHumanized(date, lang) });
const addCopyButton = (data) => <span>{data}<CopyButton icon={'clone'} data={data}/></span>;
const capitalizeAndSpace = (data) => {
    const result = data.replace(/[a-z](?=\d)|\d(?=[a-z])/gi, '$& ');
    return result.charAt(0).toUpperCase() + result.slice(1);
};
const getDuration = (data, t) => TIMEOUT_DURATION[data] + ' ' + t('minutes');

export default (t, lang) => {
    return {
        general: [
            {
                header: t('Sandbox Environment'),
                accessor: 'system',
                parser: (data) => capitalizeAndSpace(data)
            },
            {
                header: t('Scan Result'),
                accessor: 'scan_all_result_a',
            },
            {
                header: t('Duration'),
                accessor: 'timeout',
                parser: (data) => getDuration(data, t)
            },
            {
                header: t('Scan Time'),
                accessor: 'request_time',
                parser: (data) => getHumanizedDate(data, t, lang)
            },
            {
                header: t('RAW Data'),
                accessor: 'downloadRawData'
            }
        ],
        processes: {
            main: [
                {
                    header: t('Cmd'),
                    accessor: 'cmd',
                },
                {
                    header: t('Image'),
                    accessor: 'image',
                },
                {
                    header: t('Parent PID'),
                    accessor: 'ppid',
                },
                {
                    header: t('PID'),
                    accessor: 'pid',
                },
                {
                    header: t('Process ID'),
                    accessor: 'procid',
                },
                {
                    header: t('Process PID'),
                    accessor: 'procid_parent',
                },
                {
                    header: t('Started'),
                    accessor: 'started',
                },
                {
                    header: t('Terminated'),
                    accessor: 'terminated',
                },
            ],
        },
        network: {
            flows: [
                {
                    Header: t('Destination'),
                    accessor: 'dst',
                },
                {
                    Header: t('Source'),
                    accessor: 'src'
                },
                {
                    Header: t('Source Port'),
                    accessor: 'source_port'
                },
                {
                    Header: t('TX Packets'),
                    accessor: 'tx_packets'
                },
                {
                    Header: t('TX Bytes'),
                    accessor: 'tx_bytes'
                },
                {
                    Header: t('First Seen'),
                    accessor: 'first_seen',
                    parser: (data) => getHumanizedDate(data, t, lang)
                },
                {
                    Header: t('Last Seen'),
                    accessor: 'last_seen',
                    parser: (data) => getHumanizedDate(data, t, lang)
                },
            ],
            requests: [
                {
                    Header: t('Domain Name'),
                    accessor: 'domains',
                },
                {
                    Header: t('Flow'),
                    accessor: 'flow',
                }
            ],
        },
        signatures: {
            main: [
                {
                    header: t('Name'),
                    accessor: 'name'
                },
                {
                    header: t('Label'),
                    accessor: 'label'
                },
                {
                    header: t('Tags'),
                    accessor: 'tags'
                },
                {
                    header: t('TTP'),
                    accessor: 'ttp'
                },
            ],
            indicators: {
                main: [
                    {
                        Header: t('PID'),
                        accessor: 'pid',
                    },
                    {
                        Header: t('Process ID'),
                        accessor: 'procid'
                    },
                    {
                        Header: t('Description'),
                        accessor: 'description'
                    },
                    {
                        Header: t('Indicators of Compromise'),
                        accessor: 'ioc',
                        parser: (data) => addCopyButton(data)
                    }
                ]
            },
        }
    };
};
